import React from 'react';
import "../Figure.css"


function Figure10() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> PK/GFP</th>
              <th> 20 µg/mL </th>
              <th> 10 µg/mL </th>
              <th> 5 µg/mL </th>
              <th> 2.5 µg/mL </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> RT </th>
              <td> 65 -&gt; 62 </td>
              <td> 31 -&gt; 32 </td>
              <td> 16 -&gt; 16 </td>
              <td> 91 -&gt; 83 </td>
            </tr> 
            <tr>
              <th> 30°C </th>
              <td> 71 -&gt; 60 </td>
              <td> 41 -&gt; 29 </td>
              <td> 20 -&gt; 16 </td>
              <td> 10 -&gt; 8 </td>
            </tr>
            <tr>
              <th> 37°C </th>
              <td> 68 -&gt; 61 </td>
              <td> 32 -&gt; 27 </td>
              <td> 18 -&gt; 14 </td>
              <td> 10 -&gt; 8 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure10;